import { Component, OnInit } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ApifirstService } from 'src/app/service/apifirst.service';
import { DraggablemodalComponent } from '../draggablemodal/draggablemodal.component';
@Component({
  selector: 'app-diagnostic',
  templateUrl: './diagnostic.component.html',
  styleUrls: ['./diagnostic.component.scss']
})
export class DiagnosticComponent implements OnInit {
	showTitle: boolean = true;
	public isShow=true;
	public isShow1=true;
	public isShow3=true;
	public isShow6=true;
	public isShow8=true;
	public isShow9=true;
  public vindetail:any;
  public userId:any;
  public tokenDetails:any;
  public Vinnumber:any;
  constructor(
    private modalService: NgbModal,public service:ApifirstService
   ) { }

  ngOnInit(): void {
    this.service.tokenObj.subscribe((data)=>{
    this.tokenDetails=data
    })
    this.service.tokenVinNum.subscribe((data)=>{
      this.Vinnumber=data
      })
  }
  onButtonGroupClick($event:any) {
    this.showTitle = false;
    let clickedElement = $event.target || $event.srcElement;
    if (clickedElement.nodeName === "BUTTON") {
      let isCertainButtonAlreadyActive = clickedElement.parentElement.querySelector(".active");
      if (isCertainButtonAlreadyActive) {
        isCertainButtonAlreadyActive.classList.remove("active");
      }
      else {
        clickedElement.className += " active";
      }
    }
  }
  openModal(){
    this.service.userId.subscribe((data)=>{
      this.userId=data
    })
    const req={
      "userId":this.userId,
      "sessionSource":"gfdrs",
      "vin":this.Vinnumber
      }
    this.service.createSession(req).subscribe((data:any)=>{
      console.log(data,"session id at click of start ")
      localStorage.setItem("sessionID",data)
      this.service.fromResume.next(false);
      this.service.fromCapture.next(false)
      this.service.navigateSymptom.next('');
    })
    const modalRef = this.modalService.open(DraggablemodalComponent, { windowClass : "myCustomModalClass"});
     modalRef.result.then(
         result => {
             console.log(result);
         },
         reason => {}
     );
  }

}
